import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Save, X } from 'lucide-react';

export default function Editor({ addNote }) {
  const nav = useNavigate();
  const loc = useLocation();
  const editNote = loc.state?.editNote;

  const [t, setT] = useState(editNote?.title || '');
  const [c, setC] = useState(editNote?.content || '');

  const save = () => {
    if(!t.trim() || !c.trim()) return;
    addNote({ 
        id: editNote?.id || Date.now(), 
        title: t, 
        content: c, 
        isWishlisted: editNote?.isWishlisted || false,
        date: new Date().toLocaleDateString('en-US', {month:'short', day:'numeric'}) 
    });
    nav('/all-notes');
  };

  return (
    <div className="bg-white p-8 rounded-[2.5rem] shadow-xl border h-[75vh] flex flex-col animate-in slide-in-from-bottom-10">
      <div className="flex justify-between items-center mb-6">
        <h2 className="font-black text-gray-300 uppercase tracking-widest text-xs">{editNote ? 'Editing' : 'New'}</h2>
        <button onClick={()=>nav(-1)}><X size={24} className="text-gray-300"/></button>
      </div>
      <input className="text-4xl font-black outline-none mb-6 text-gray-800" placeholder="Title" value={t} onChange={e=>setT(e.target.value)} autoFocus />
      <textarea className="flex-1 text-xl text-gray-500 outline-none resize-none leading-relaxed" placeholder="Content..." value={c} onChange={e=>setC(e.target.value)} />
      <button onClick={save} className="w-full bg-indigo-600 text-white py-5 rounded-2xl font-black text-lg active:scale-95 transition-all flex items-center justify-center gap-3">
        <Save size={24}/> {editNote ? 'UPDATE' : 'SAVE'}
      </button>
    </div>
  );
}